const APP_DOMAIN = 'app'
const APP_KEY = {
  VERSION: 'version',
  INITIAL_QUERY_PARAMS: 'initialQueryParams',
  USER_AGENT: 'userAgent',
  SHOULD_RENDER_NOT_FOUND_PAGE: 'shouldRenderNotFoundPage',
  HAS_WEBP_SUPPORT: 'hasWebpSupport',
  RENDER_COUNT: 'renderCount',
  IS_MOBILE_MENU_OPEN: 'isMobileMenuOpen'
}

const APP_PATH = {
  VERSION: `${APP_DOMAIN}.${APP_KEY.VERSION}`,
  USER_AGENT: `${APP_DOMAIN}.${APP_KEY.USER_AGENT}`,
  INITIAL_QUERY_PARAMS: `${APP_DOMAIN}.${APP_KEY.INITIAL_QUERY_PARAMS}`,
  HAS_WEBP_SUPPORT: `${APP_DOMAIN}.${APP_KEY.HAS_WEBP_SUPPORT}`,
  SHOULD_RENDER_NOT_FOUND_PAGE: `${APP_DOMAIN}.${APP_KEY.SHOULD_RENDER_NOT_FOUND_PAGE}`,
  RENDER_COUNT: `${APP_DOMAIN}.${APP_KEY.RENDER_COUNT}`,
  IS_MOBILE_MENU_OPEN: `${APP_DOMAIN}.${APP_KEY.IS_MOBILE_MENU_OPEN}`
}

const APP_VERSION = npm_package_version

const APP_STATE = {
  [APP_KEY.VERSION]: APP_VERSION,
  [APP_KEY.USER_AGENT]: null,
  [APP_KEY.INITIAL_QUERY_PARAMS]: {},
  [APP_KEY.HAS_WEBP_SUPPORT]: null,
  [APP_KEY.SHOULD_RENDER_NOT_FOUND_PAGE]: null,
  [APP_KEY.IS_MOBILE_MENU_OPEN]: null,
  [APP_KEY.RENDER_COUNT]: 0
}

/**
 * Classname on the `document.body` when the view has a modal.
 * @type {string}
 */
const APP_BODY_CLASSNAME = 'body_modal'

const APP_GLOBAL_KEY = {
  IS_BOT: '__IS_BOT__',
  INITIAL_STATE: '__INITIAL_STATE__'
}

export {
  APP_DOMAIN,
  APP_KEY,
  APP_PATH,
  APP_STATE,
  APP_VERSION,
  APP_BODY_CLASSNAME,
  APP_GLOBAL_KEY
}

export const APP_QUERY_PARAMETER = {
  LAST_ID: 'lastId',
  LIMIT: 'limit',
  TRAINING_JWT: 'trainingJwt',
  UTM_SOURCE: 'utm_source',
  PLATFORM: 'platform',
  TRAINING_JTI: 'trainingJti',
  SHOW_ONBOARDING: 'showOnboarding'
}

export * from './features'

export const FREE_VS_PREMIUM_FEATURES_ID = 'FreeVsPremiumFeatures'
